import type { LiveInfo, LiveStreamRef } from "@tih/shared";

function streamRefHasSource(ref: LiveStreamRef | null | undefined): boolean {
  return Boolean(ref?.source || ref?.youtubeId);
}

export function hasConfiguredStream(info: LiveInfo | null | undefined): boolean {
  if (!info) return false;
  return streamRefHasSource(info.current) || streamRefHasSource(info.last);
}

/** True only when admin has live mode on and a current stream is configured. */
export function isBroadcastLive(info: LiveInfo | null | undefined): boolean {
  return Boolean(info?.isLive && streamRefHasSource(info.current));
}

export function resolveShowingStream(info: LiveInfo): LiveStreamRef | null {
  if (isBroadcastLive(info) && info.current) return info.current;
  if (streamRefHasSource(info.last)) return info.last ?? null;
  if (streamRefHasSource(info.current)) return info.current ?? null;
  return null;
}
